import i18next from 'i18next';
import React from 'react';
import en from './i18n/en';
import ptBr from './i18n/pt-br';

i18next.addResourceBundle('pt-br', 'receita/cadastro/produto', ptBr);
i18next.addResourceBundle('en', 'receita/cadastro/produto', en);

const ProdutoConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/suprimentos/produto',
      component: React.lazy(() => import('./Produto')),
    },
  ],
};

export default ProdutoConfig;
